import { defineStore } from 'pinia';
import type { GuideStep } from '~/utils/agent-chat';

/**
 * The page guide that runs now. It is a store, so the guide stays across the page changes that its
 * steps make. The user starts it from an answer of Suge.
 */
export const usePageGuideStore = defineStore('pageGuide', {
  state: () => ({
    steps: [] as GuideStep[],
    index: 0,
    /** A new value for each start, so the same guide can start again. */
    run: 0,
  }),

  getters: {
    active: state => state.steps.length > 0,
    step: state => state.steps[state.index] ?? null,
    isLast: state => state.index >= state.steps.length - 1,
  },

  actions: {
    start(steps: GuideStep[]) {
      this.steps = steps;
      this.index = 0;
      this.run++;
    },

    next() {
      if (this.index < this.steps.length - 1) this.index++;
      else this.close();
    },

    back() {
      if (this.index > 0) this.index--;
    },

    close() {
      this.steps = [];
      this.index = 0;
    },
  },
});
